import { useQuery } from '@tanstack/react-query';
import { makeItineraryManagerApi } from 'services/ItineraryManagerApi';
import { IVoucherV2Upload } from 'services/ItineraryManagerApi/types';
import { Upload, EUploadTag } from 'services/BackendApi';

// Extended Upload interface with deleteUrl for VoucherV2
export interface UploadWithDeleteUrl extends Upload {
  deleteUrl?: string;
}

const transformVoucherUploadToUpload = (voucherUpload: IVoucherV2Upload, voucherUuid: string): UploadWithDeleteUrl => ({
  uuid: `voucher-${voucherUuid}-${voucherUpload.fileName}`, // Generate unique ID since original doesn't have uuid
  filename: voucherUpload.fileName,
  displayName: voucherUpload.fileName,
  url: voucherUpload.downloadUrl,
  size: '0', // Size not provided in IVoucherV2Upload
  tag: EUploadTag.VOUCHERV2,
  ownerType: 'voucher',
  ownerUuid: voucherUuid,
  createdAt: voucherUpload.createdAt,
  updatedAt: voucherUpload.createdAt, // Use createdAt since updatedAt not provided
  deleteUrl: voucherUpload.deleteUrl, // Include deleteUrl for VoucherV2
});

export const useVoucherUploads = (voucherUuid: string | undefined) => {
  const itineraryManagerApi = makeItineraryManagerApi();

  return useQuery({
    queryKey: ['voucherPdfUploads', voucherUuid],
    queryFn: async () => {
      if (!voucherUuid) {
        return [];
      }
      
      const response = await itineraryManagerApi.getVoucherPdfUploads(voucherUuid);
      const voucherUploads: IVoucherV2Upload[] = response.data || [];
      
      return voucherUploads.map((upload: IVoucherV2Upload) => 
        transformVoucherUploadToUpload(upload, voucherUuid)
      );
    },
    enabled: Boolean(voucherUuid),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};